/**
 * FeaturePath: 會員系統-個人資訊-學習履歷
 * Accountable: Landy Chu, AlexCH Cheng
 */

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
